import { render, staticRenderFns } from "./BaseCardTransition.vue?vue&type=template&id=bb0a767a"
import script from "./BaseCardTransition.vue?vue&type=script&lang=js"
export * from "./BaseCardTransition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports